<template>
  <div v-show="isLoading" :class="{loading: isLoading}">
    <img class="img" src="../../assets/loading.gif" />
  </div>
</template>

<style scoped>
.loading {
  width: 100vw;
  height: 100vh;
  background: rgba(112, 112, 112, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>

<script>
export default {
  name: 'LoadingScreen',
  props: {
    isLoading: {
      type: Boolean
    }
  }
}
</script>